class SstTutorSlider {
    constructor(container) {
        this.container = container;
        this.track = container.querySelector('.sst-tutor-slider-track');
        this.slides = Array.from(this.track.querySelectorAll('.sst-tutor-card:not(.sst-clone)'));
        this.prevBtn = container.querySelector('.sst-slider-prev');
        this.nextBtn = container.querySelector('.sst-slider-next');

        if (!this.track || this.slides.length === 0) return;

        this.slideCount = this.slides.length;
        this.currentIndex = 0;
        this.autoPlayInterval = null;
        this.isTransitioning = false;
        this.cloneCount = 0;

        // Configuration
        this.autoPlaySpeed = 5000;
        this.infinite = true;

        // Touch properties
        this.startX = 0;
        this.currentX = 0;
        this.isDragging = false;
        this.startPos = 0;

        this.init();
    }

    getSlidesPerView() {
        if (window.innerWidth >= 1024) return 3;
        if (window.innerWidth >= 768) return 2;
        return 1;
    }

    init() {
        // Clear existing clones if any (for re-init)
        this.track.querySelectorAll('.sst-clone').forEach(clone => clone.remove());

        // Clone slides for infinite loop
        if (this.infinite && this.slideCount > this.getSlidesPerView()) {
            this.cloneSlides();
        } else {
            this.cloneCount = 0;
            this.currentIndex = 0;
        }

        this.updateDimensions();
        this.addEventListeners();
        this.startAutoPlay();
    }

    cloneSlides() {
        const slidesPerView = 3; // Buffer for clones
        this.cloneCount = slidesPerView;

        const frontClones = this.slides.slice(0, slidesPerView).map(slide => {
            const clone = slide.cloneNode(true);
            clone.classList.add('sst-clone');
            return clone;
        });

        const backClones = this.slides.slice(-slidesPerView).map(slide => {
            const clone = slide.cloneNode(true);
            clone.classList.add('sst-clone');
            return clone;
        });

        frontClones.forEach(clone => this.track.appendChild(clone));
        backClones.reverse().forEach(clone => this.track.insertBefore(clone, this.track.firstChild));

        this.currentIndex = slidesPerView;
        this.updateTrackPosition(false);
    }

    updateDimensions() {
        this.updateTrackPosition(false);
    }

    updateTrackPosition(animate = true) {
        const spv = this.getSlidesPerView();
        const percentage = -(this.currentIndex * (100 / spv));

        this.track.style.transition = animate ? 'transform 0.5s ease-in-out' : 'none';
        this.track.style.transform = `translateX(${percentage}%)`;
    }

    move(direction) {
        if (this.isTransitioning) return;
        this.isTransitioning = true;

        this.currentIndex += direction;
        this.updateTrackPosition(true);

        const onTransitionEnd = (e) => {
            if (e.target !== this.track) return;
            this.checkInfiniteLoop();
            this.isTransitioning = false;
            this.track.removeEventListener('transitionend', onTransitionEnd);
        };

        this.track.addEventListener('transitionend', onTransitionEnd);
    }

    checkInfiniteLoop() {
        if (!this.infinite || this.cloneCount === 0) return;

        const realCount = this.slideCount;

        if (this.currentIndex >= realCount + this.cloneCount) {
            this.currentIndex = this.cloneCount;
            this.updateTrackPosition(false);
        } else if (this.currentIndex < this.cloneCount) {
            this.currentIndex = realCount + this.cloneCount - 1;
            // Precise jump logic
            this.currentIndex = this.currentIndex; // Placeholder for future logic if needed
            // Correct jump: if we are at index 2 (clone), we jump to real end index
            if (this.currentIndex === this.cloneCount - 1) {
                this.currentIndex = realCount + this.cloneCount - 1;
            }
            this.updateTrackPosition(false);
        }
    }

    addEventListeners() {
        // Prev/Next buttons
        if (this.prevBtn) {
            this.prevBtn.onclick = (e) => {
                e.preventDefault();
                this.stopAutoPlay();
                this.move(-1);
                this.startAutoPlay();
            };
        }

        if (this.nextBtn) {
            this.nextBtn.onclick = (e) => {
                e.preventDefault();
                this.stopAutoPlay();
                this.move(1);
                this.startAutoPlay();
            };
        }

        // Resize
        window.addEventListener('resize', () => this.updateDimensions());

        // Pause on interaction
        this.container.addEventListener('mouseenter', () => this.stopAutoPlay());
        this.container.addEventListener('mouseleave', () => this.startAutoPlay());

        // Touch events
        this.track.addEventListener('touchstart', (e) => this.touchStart(e), { passive: true });
        this.track.addEventListener('touchmove', (e) => this.touchMove(e), { passive: true });
        this.track.addEventListener('touchend', () => this.touchEnd());
    }

    touchStart(e) {
        this.stopAutoPlay();
        this.startX = e.touches[0].clientX;
        this.isDragging = true;
    }

    touchMove(e) {
        if (!this.isDragging) return;
        this.currentX = e.touches[0].clientX;
    }

    touchEnd() {
        if (!this.isDragging) return;
        this.isDragging = false;

        const diff = this.startX - this.currentX;
        const threshold = 50; // swipe threshold

        if (Math.abs(diff) > threshold) {
            if (diff > 0) {
                this.move(1);
            } else {
                this.move(-1);
            }
        }

        this.startAutoPlay();
    }

    startAutoPlay() {
        if (this.autoPlayInterval) clearInterval(this.autoPlayInterval);
        this.autoPlayInterval = setInterval(() => {
            if (!this.isTransitioning) this.move(1);
        }, this.autoPlaySpeed);
    }

    stopAutoPlay() {
        if (this.autoPlayInterval) {
            clearInterval(this.autoPlayInterval);
            this.autoPlayInterval = null;
        }
    }
}

// Initial init
const initTutorSliders = () => {
    const sliders = document.querySelectorAll('.sst-tutor-slider-section');
    sliders.forEach(slider => {
        if (!slider.dataset.initialized) {
            new SstTutorSlider(slider);
            slider.dataset.initialized = 'true';
        }
    });
};

document.addEventListener('DOMContentLoaded', initTutorSliders);

// Handle Shopify Theme Editor events
document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('sst-tutor-slider-section')) {
        new SstTutorSlider(e.target);
        e.target.dataset.initialized = 'true';
    }
});
